<template>
  <div id="landing-header" class="w-full m-2 mb-5 flex justify-between">
    <div class="flex flex-col">
      <DbLogo></DbLogo>
      <div class="flex items-center">
        <div class="text-[1.7rem] font-bold text-left">Cargo</div>
        <div id="website title" class="text-md mx-5 font-medium flex items-end">
          {{ $t("landing.apptitle") }}
        </div>
      </div>
    </div>

    <div id="language switcher" class="col-start-1 flex">
      <LocaleChanger :landingPage="true"></LocaleChanger>
    </div>
  </div>
  <div id="landing-main" class="w-full bg-landing bg-contain bg-no-repeat px-2">
    <div class="w-full grid grid-cols-3 mt-10">
      <div class="col-start-1">
        <div id="text-div" class="text-left text-xl font-bold">
          <p>{{ $t("landing.motto") }}</p>
        </div>
        <div
          id="red-line"
          class="border-b-8 mb-36 border-red-600 w-[77.07px] rounded-md"
        ></div>
      </div>
      <div class="col-start-1 col-span-3 mx-7 my-5 mb-20">
        <ResetPasswordLinkComponent></ResetPasswordLinkComponent>
      </div>
    </div>
  </div>
  <div id="landing-footer" class="w-full bg-gray-100 px-2">
    <div id="footer-column" class="flex flex-col items-start">
      <p class="font-bold mb-5">
        {{ $t("landing.footer.terms_and_conditions") }}
      </p>
      <a href="https://www.dbcargo.com/rail-de-de/agb" target="_blank">
        {{ $t("landing.footer.general_terms_and_conditions") }}
      </a>
      <a
        href="https://www.dbcargo.com/rail-de-de/impressum-4970666"
        target="_blank"
      >
        {{ $t("landing.footer.legal_info") }}
      </a>
      <a
        href="https://www.dbcargo.com/rail-de-de/Datenschutz/datenschutzhinweise-4983542"
        target="_blank"
      >
        {{ $t("landing.footer.privacy") }}
      </a>
      <a href="https://www.dbcargo.com/rail-de-de/link2rail" target="_blank">
        {{ $t("landing.footer.e-services") }}
      </a>
      <a href="https://www.dbcargo.com/rail-de-de" target="_blank">
        {{ $t("landing.footer.website") }}
      </a>
      <div class="flex flex-col justify-end text-gray-400 mt-5">
        © 2024 DB Cargo AG
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import LocaleChanger from "@/components/LocaleChanger.vue";
import { DbLogo } from "@db-ui/v-elements-enterprise/dist/components";
import ResetPasswordLinkComponent from "@/components/ResetPasswordLinkComponent.vue";

export default defineComponent({
  components: { ResetPasswordLinkComponent, LocaleChanger, DbLogo },
  name: "ResetLinkView",

  setup() {
    return {};
  },
});
</script>
